import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { BrandingService } from '../services/branding.service';

export const uploadGuard: CanActivateFn = () => {
  const brandingService = inject(BrandingService);
  const router = inject(Router);

  return brandingService.uploadExternalPolicy$.pipe(
    map(canUpload => canUpload ? true : router.createUrlTree(['/']))
  );
};
